export const getKeepsakeShareInfo = ({
  pageId = '',
  explicitUrl = '',
  explicitLabel = '',
} = {}) => {
  const fallbackUrl = typeof window !== 'undefined' ? window.location.href : '';
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const shareUrl = explicitUrl || fallbackUrl || (pageId && origin ? `${origin}/${pageId}` : '');

  let shortLinkLabel = explicitLabel;
  if (!shortLinkLabel && shareUrl) {
    try {
      const parsedUrl = new URL(shareUrl);
      const path = parsedUrl.pathname.replace(/^\/+/, '') || pageId || 'gift';
      shortLinkLabel = `${parsedUrl.host}/${path}`.slice(0, 34);
    } catch {
      shortLinkLabel = String(shareUrl).replace(/^https?:\/\//, '').slice(0, 34);
    }
  }

  return {
    shareUrl,
    shortLinkLabel: shortLinkLabel || (pageId ? `lumirae/${String(pageId).slice(0, 8)}` : 'copy link'),
  };
};

export const copyKeepsakeLink = async (shareUrl) => {
  if (!shareUrl) return false;
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(shareUrl);
    return true;
  }

  const input = document.createElement('textarea');
  input.value = shareUrl;
  input.setAttribute('readonly', '');
  input.style.position = 'fixed';
  input.style.left = '-9999px';
  document.body.appendChild(input);
  input.select();
  const copied = document.execCommand('copy');
  document.body.removeChild(input);
  return copied;
};

export const saveKeepsakeCardElement = async (element, filename = 'lumirae-keepsake-card.png') => {
  if (!element) return false;
  const html2canvas = (await import('html2canvas')).default;
  const canvas = await html2canvas(element, {
    backgroundColor: null,
    scale: Math.min(3, window.devicePixelRatio || 2),
    useCORS: true,
  });
  const link = document.createElement('a');
  link.href = canvas.toDataURL('image/png');
  link.download = filename;
  link.click();
  return true;
};
